<template>
  <v-app id="app">
    <!-- <app-toolbar app></app-toolbar> -->
    <v-content>
      <transition name="router-anim">
        <router-view></router-view>
      </transition>
    </v-content>
    <!-- <app-footer style="possiton:absolute;z-index:-1"></app-footer> -->
  </v-app>
</template>

<script>
import AppToolbar from "./../components/toolbars/AppToolbar";

export default {
  data() {
    return {};
  },
  components: {
    AppToolbar
  }
};
</script>

<style>
.router-anim-enter-active {
  animation: coming 0.5s;
  animation-delay: 0.5s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 0.5s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AppHome.vue